import classes from "./GlobalBanner.module.less";
import { type ReactNode } from "react";
import classnames from "classnames";

interface GlobalBannerProps {
  children: ReactNode;
  type?: "primary" | "secondary";
  icon?: ReactNode;
  className?: string;
  onClick?: () => void;
}

const GlobalBanner = ({ type = "primary", icon, children, className, onClick }: GlobalBannerProps) => {
  return (
    <div className={classnames(classes.container, classes[type], className)} onClick={onClick}>
      {icon}
      <div>{children}</div>
    </div>
  );
};

export default GlobalBanner;
